var DesignerDesignFiles = (function() {
  function init() {
    var root = document.querySelector('[data-designer-design-files]');
    if (root) initStudio(root);
    var job = document.querySelector('[data-upload-status]');
    if (job) initJob(job);
  }

  function initStudio(root) {
    var modes = root.querySelectorAll('[data-ddf-mode]');
    var panels = root.querySelectorAll('[data-ddf-panel]');
    var startMode = root.getAttribute('data-mode') || 'single';

    function showMode(mode) {
      for (var i = 0; i < modes.length; i++) {
        modes[i].classList.toggle('is-active', modes[i].getAttribute('data-ddf-mode') === mode);
      }
      for (var j = 0; j < panels.length; j++) {
        var on = panels[j].getAttribute('data-ddf-panel') === mode;
        if (on) panels[j].removeAttribute('hidden');
        else panels[j].setAttribute('hidden', 'hidden');
      }
    }

    for (var m = 0; m < modes.length; m++) {
      modes[m].addEventListener('click', function() {
        showMode(this.getAttribute('data-ddf-mode'));
      });
    }
    showMode(startMode);
    initSingle(root);
    initZip(root);
  }

  function initSingle(root) {
    var form = document.getElementById('ddf-upload-form');
    if (!form) return;
    var input = document.getElementById('ddf-file');
    var drop = document.getElementById('ddf-drop');
    var status = document.getElementById('ddf-status');
    var codeInput = document.getElementById('ddf-item-code');
    var cards = document.getElementById('ddf-cards');
    var uploading = false;

    cards.addEventListener('click', function(event) {
      var card = event.target.closest ? event.target.closest('.ddf-card') : null;
      if (!card || !cards.contains(card)) return;
      focusCard(card);
    });

    var skip = document.getElementById('ddf-skip');
    if (skip) {
      skip.addEventListener('click', function() {
        var list = cardList();
        if (list.length < 2) return;
        var current = currentCard();
        var index = list.indexOf(current);
        var next = list[index + 1] || list[0];
        if (current && next && current !== next) {
          cards.appendChild(current);
          focusCard(next);
          setStatus('');
        }
      });
    }

    ['dragenter', 'dragover'].forEach(function(name) {
      drop.addEventListener(name, function(event) {
        event.preventDefault();
        drop.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function(name) {
      drop.addEventListener(name, function(event) {
        event.preventDefault();
        drop.classList.remove('is-over');
      });
    });
    drop.addEventListener('drop', function(event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) upload(file);
    });

    input.addEventListener('change', function() {
      if (input.files && input.files[0]) upload(input.files[0]);
    });

    form.addEventListener('submit', function(event) {
      if (!window.fetch) return;
      event.preventDefault();
      if (input.files && input.files[0]) upload(input.files[0]);
      else setStatus('Choose a design file first.');
    });

    document.addEventListener('paste', function(event) {
      if (!root.contains(document.activeElement) && isTypingTarget(document.activeElement)) return;
      var single = root.querySelector('[data-ddf-panel="single"]');
      if (!single || single.hasAttribute('hidden')) return;
      var file = fileFromClipboard(event);
      if (!file) return;
      event.preventDefault();
      upload(namedImage(file));
    });

    function upload(file) {
      if (uploading || !file) return;
      var code = codeInput.value;
      if (!code) return;
      uploading = true;
      setStatus('Uploading the design for ' + code + '…');
      drop.classList.add('is-busy');
      var body = new FormData();
      body.append('item_code', code);
      var designer = form.querySelector('input[name="designer_id"]');
      if (designer) body.append('designer_id', designer.value);
      body.append('file', namedImage(file));

      fetch(form.getAttribute('action'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      }).then(function(response) {
        return response.text().then(function(text) {
          var json = {};
          if (text) {
            try { json = JSON.parse(text); } catch (error) { json = {}; }
          }
          if (!response.ok || json.success === false) {
            throw new Error(json.error || 'The design file could not be saved.');
          }
          return json;
        });
      }).then(function(json) {
        input.value = '';
        var card = currentCard();
        var upcoming = nextCard(card);
        if (card) card.parentNode.removeChild(card);
        var remaining = typeof json.remaining_count === 'number' ? json.remaining_count : cardList().length;
        setCount(remaining);
        setStatus(json.notice || 'Saved.');
        if (!upcoming && remaining > 0) {
          window.location.reload();
          return;
        }
        if (!upcoming) showDone();
        else focusCard(upcoming);
      }).catch(function(error) {
        setStatus(error.message || 'The design file could not be saved.');
      }).then(function() {
        uploading = false;
        drop.classList.remove('is-busy');
      });
    }

    function cardList() {
      return Array.prototype.slice.call(cards.querySelectorAll('.ddf-card'));
    }

    function currentCard() {
      var code = codeInput.value;
      var list = cardList();
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-item-code') === code) return list[i];
      }
      return list[0] || null;
    }

    function nextCard(card) {
      var list = cardList();
      var index = list.indexOf(card);
      if (index >= 0 && list[index + 1]) return list[index + 1];
      for (var i = 0; i < list.length; i++) {
        if (list[i] !== card) return list[i];
      }
      return null;
    }

    function focusCard(card) {
      var list = cardList();
      for (var i = 0; i < list.length; i++) list[i].classList.remove('is-current');
      card.classList.add('is-current');
      codeInput.value = card.getAttribute('data-item-code');
      document.getElementById('ddf-focus-title').textContent = card.getAttribute('data-title');
      document.getElementById('ddf-focus-code').textContent = card.getAttribute('data-item-code');
      var image = card.getAttribute('data-image');
      var img = document.getElementById('ddf-focus-image');
      var placeholder = document.getElementById('ddf-focus-placeholder');
      if (image) {
        img.src = image;
        img.hidden = false;
        placeholder.classList.add('is-hidden');
      } else {
        img.removeAttribute('src');
        img.hidden = true;
        placeholder.textContent = (card.getAttribute('data-item-code') || '?').charAt(0);
        placeholder.classList.remove('is-hidden');
      }
      var position = list.indexOf(card) + 1;
      document.getElementById('ddf-step').textContent = position + ' of ' + list.length;
      if (card.scrollIntoView) card.scrollIntoView({ block: 'nearest' });
    }

    function setCount(count) {
      var line = document.getElementById('ddf-count-line');
      var queue = document.getElementById('ddf-queue-count');
      if (queue) queue.textContent = String(count);
      if (line && count > 0) {
        if (count === 1) line.textContent = '1 product still needs a design file';
        else line.textContent = count + ' products still need a design file';
      }
      var badgeLink = document.querySelector('a.topbar-notification-link[href$="/designer_design_files"]');
      if (!badgeLink) return;
      if (count > 0) {
        var badge = badgeLink.querySelector('.topbar-notification-badge');
        if (badge) badge.textContent = count > 99 ? '99+' : String(count);
      } else if (badgeLink.parentNode) {
        badgeLink.parentNode.parentNode.removeChild(badgeLink.parentNode);
      }
    }

    function showDone() {
      var workspace = document.getElementById('ddf-workspace');
      var empty = document.getElementById('ddf-empty');
      if (workspace) workspace.classList.add('is-hidden');
      if (empty) empty.classList.remove('is-hidden');
      var line = document.getElementById('ddf-count-line');
      if (line) line.textContent = 'All design files are in';
    }

    function setStatus(message) {
      status.textContent = message || '';
    }
  }

  function initZip(root) {
    var form = document.getElementById('ddf-zip-form');
    var input = document.getElementById('ddf-zip-file');
    var drop = document.getElementById('ddf-zip-drop');
    var label = document.getElementById('ddf-zip-label');
    var status = document.getElementById('ddf-zip-status');
    if (!form || !input || !drop) return;

    ['dragenter', 'dragover'].forEach(function(name) {
      drop.addEventListener(name, function(event) {
        event.preventDefault();
        drop.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function(name) {
      drop.addEventListener(name, function(event) {
        event.preventDefault();
        drop.classList.remove('is-over');
      });
    });
    drop.addEventListener('drop', function(event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) stageZip(file);
    });
    input.addEventListener('change', function() {
      if (input.files && input.files[0]) stageZip(input.files[0]);
    });
    form.addEventListener('submit', function(event) {
      var file = input.files && input.files[0];
      if (!file) {
        event.preventDefault();
        status.textContent = 'Choose a zip file first.';
        return;
      }
      if (!/\.zip$/i.test(file.name || '')) {
        event.preventDefault();
        status.textContent = 'That file needs to be a .zip.';
        return;
      }
      if (file.size > 200 * 1024 * 1024) {
        event.preventDefault();
        status.textContent = 'That zip is larger than 200 MB.';
        return;
      }
      status.textContent = 'Uploading the zip…';
    });

    function stageZip(file) {
      if (!/\.zip$/i.test(file.name || '')) {
        status.textContent = 'That file needs to be a .zip.';
        return;
      }
      if (file.size > 200 * 1024 * 1024) {
        status.textContent = 'That zip is larger than 200 MB.';
        return;
      }
      if (window.DataTransfer) {
        var transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
      }
      if (label) label.textContent = file.name;
      if (input.files && input.files[0]) form.submit();
      else status.textContent = file.name + ' is ready. Press Match and upload.';
    }
  }

  function initJob(job) {
    var status = job.getAttribute('data-upload-status');
    if (status !== 'queued' && status !== 'processing') return;
    var url = job.getAttribute('data-poll-url');
    function poll() {
      fetch(url, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() }
      }).then(function(response) { return response.json(); }).then(function(data) {
        if (data.status === 'queued' || data.status === 'processing') {
          window.setTimeout(poll, 2500);
        } else {
          window.location.reload();
        }
      }).catch(function() {
        window.setTimeout(poll, 4000);
      });
    }
    window.setTimeout(poll, 2500);
  }

  function fileFromClipboard(event) {
    var data = event.clipboardData;
    if (!data) return null;
    if (data.files && data.files.length) return data.files[0];
    if (!data.items) return null;
    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i].kind === 'file') return data.items[i].getAsFile();
    }
    return null;
  }

  function namedImage(file) {
    if (file.name && /\.(png|jpe?g|webp)$/i.test(file.name)) return file;
    var ext = 'png';
    if (file.type === 'image/jpeg') ext = 'jpg';
    else if (file.type === 'image/webp') ext = 'webp';
    if (typeof File !== 'function') return file;
    return new File([file], 'design.' + ext, { type: file.type || 'image/png' });
  }

  function isTypingTarget(node) {
    if (!node) return false;
    var tag = node.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || node.isContentEditable;
  }

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  return { init: init };
})();

document.addEventListener('DOMContentLoaded', DesignerDesignFiles.init);

export default DesignerDesignFiles;
